import React from 'react';
import Icon from '../../../components/AppIcon';


const QuickActions = ({ onActionClick, selectedAgent }) => {
  const quickActions = [
    {
      id: 'status',
      label: 'Check Status',
      icon: 'Activity',
      description: 'View current agent activity',
      color: 'text-primary'
    },
    {
      id: 'history',
      label: 'View History',
      icon: 'History',
      description: 'See past conversations',
      color: 'text-accent'
    },
    {
      id: 'template',
      label: 'Use Template',
      icon: 'FileText',
      description: 'Load message template',
      color: 'text-success'
    },
    {
      id: 'schedule',
      label: 'Schedule Task',
      icon: 'Calendar',
      description: 'Set future task',
      color: 'text-warning'
    }
  ];

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="Zap" size={20} color="var(--color-primary)" />
        <h3 className="text-base font-semibold text-foreground">Quick Actions</h3>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {quickActions?.map((action) => (
          <button
            key={action?.id}
            onClick={() => onActionClick(action?.id)}
            disabled={!selectedAgent && action?.id !== 'template'}
            className="flex items-start gap-3 p-4 bg-card border-2 border-border rounded-xl hover:border-primary hover:shadow-warm-sm transition-all duration-250 text-left disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:border-border disabled:hover:shadow-none"
          >
            <div className={`flex-shrink-0 w-10 h-10 rounded-lg bg-muted flex items-center justify-center ${action?.color}`}>
              <Icon name={action?.icon} size={20} />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-semibold text-foreground mb-1">
                {action?.label}
              </p>
              <p className="text-xs text-muted-foreground leading-relaxed">
                {action?.description}
              </p>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;